var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "transition",
    { attrs: { name: "component-fade", mode: "out-in" } },
    [
      _vm.loading
        ? _c("Spinner", { key: "1", staticClass: "mt-4" })
        : _c(
            "div",
            { key: "2" },
            [
              _c("div", [
                _c("div", { staticClass: "d-flex mb-3" }, [
                  _c("h5", { staticClass: "fw-bold" }, [
                    _vm._v(_vm._s(_vm.post.community_topic.title)),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "ms-auto d-flex" }, [
                    _c("div", { staticClass: "dropdown ms-3 d-lg-none" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-outline-dark btn-sm",
                          attrs: {
                            type: "button",
                            "data-bs-toggle": "dropdown",
                            "aria-expanded": "false",
                          },
                        },
                        [_c("i", { staticClass: "fas fa-sliders-h" })]
                      ),
                      _vm._v(" "),
                      _c(
                        "ul",
                        { staticClass: "dropdown-menu" },
                        _vm._l(_vm.communityTopics, function (communityTopic) {
                          return _c(
                            "li",
                            { key: communityTopic.id + communityTopic.title },
                            [
                              _c(
                                "a",
                                {
                                  staticClass:
                                    "dropdown-item small fw-semibold",
                                  attrs: { href: communityTopic.url },
                                },
                                [_vm._v(_vm._s(communityTopic.title))]
                              ),
                            ]
                          )
                        }),
                        0
                      ),
                    ]),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "post card mb-3" }, [
                _c("div", { staticClass: "card-body p-4 p-lg-5" }, [
                  _c("div", { staticClass: "d-flex" }, [
                    _c("div", [
                      _c("div", { staticClass: "mb-2" }, [
                        _c("small", {}, [_vm._v(_vm._s(_vm.creator))]),
                        _vm._v("\n              >\n              "),
                        _c("small", {}, [
                          _c(
                            "a",
                            {
                              staticClass: "text-dark",
                              attrs: { href: _vm.topicLink },
                            },
                            [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(_vm.post.community_topic.title) +
                                  "\n                "
                              ),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("small", { staticClass: "text-muted" }, [
                          _vm._v(_vm._s(_vm.time(_vm.post.created_at))),
                        ]),
                      ]),
                      _vm._v(" "),
                      _vm.post.title
                        ? _c("div", [
                            _c("h4", { staticClass: "fw-bold" }, [
                              _vm._v(_vm._s(_vm.post.title)),
                            ]),
                          ])
                        : _vm._e(),
                    ]),
                    _vm._v(" "),
                    _vm.isPostAuthor
                      ? _c("div", { staticClass: "ms-auto" }, [
                          _c("div", { staticClass: "dropdown" }, [
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-link btn-sm",
                                attrs: {
                                  type: "button",
                                  id: "dropdownMenuButton",
                                  "aria-haspopup": "true",
                                  "aria-expanded": "false",
                                  "data-bs-toggle": "dropdown",
                                },
                              },
                              [_c("i", { staticClass: "fas fa-ellipsis-v" })]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "dropdown-menu",
                                attrs: {
                                  "aria-labelledby": "dropdownMenuButton",
                                },
                              },
                              [
                                _c(
                                  "a",
                                  {
                                    staticClass: "dropdown-item",
                                    attrs: { href: "#" },
                                    on: {
                                      click: function ($event) {
                                        $event.preventDefault()
                                        return _vm.showPostEditModal.apply(
                                          null,
                                          arguments
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(_vm._f("translate")("Edit")) +
                                        "\n                "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("hr", { staticClass: "dropdown-divider" }),
                                _vm._v(" "),
                                _c(
                                  "a",
                                  {
                                    staticClass: "dropdown-item",
                                    attrs: { href: "#" },
                                    on: {
                                      click: function ($event) {
                                        $event.preventDefault()
                                        return _vm.showDeleteModal(_vm.post.id)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(_vm._f("translate")("Delete")) +
                                        "\n                "
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ]),
                        ])
                      : _vm._e(),
                  ]),
                  _vm._v(" "),
                  _vm.post.student_id
                    ? _c(
                        "div",
                        { staticStyle: { "white-space": "pre-wrap" } },
                        [_vm._v(_vm._s(_vm.post.body))]
                      )
                    : _c("div", {
                        staticStyle: { "white-space": "pre-wrap" },
                        domProps: {
                          innerHTML: _vm._s(_vm.markdown(_vm.post.body)),
                        },
                      }),
                  _vm._v(" "),
                  _vm.post.image
                    ? _c("div", { staticClass: "mt-2" }, [
                        _c("img", {
                          staticClass: "img-fluid",
                          attrs: { src: _vm.imgUrl },
                        }),
                      ])
                    : _vm.post.bunny_id && _vm.post.bunny_status === 3
                    ? _c("div", { staticClass: "mt-3" }, [
                        _c("div", { staticClass: "ratio ratio-16x9" }, [
                          _c("iframe", {
                            attrs: {
                              src: `https://player.mediadelivery.net/embed/25534/${_vm.post.bunny_id}?autoplay=false&preload=false`,
                              loading: "lazy",
                              allow:
                                "accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture;",
                              allowfullscreen: "true",
                            },
                          }),
                        ]),
                      ])
                    : _vm.post.video
                    ? _c("div", { staticClass: "mt-2" }, [
                        _c("div", { staticClass: "ratio ratio-16x9" }, [
                          _c("iframe", {
                            staticClass: "embed-responsive-item",
                            attrs: { src: _vm.post.video },
                          }),
                        ]),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "mt-2 d-flex" },
                    [_c("Votes", { attrs: { votable: _vm.post } })],
                    1
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "mt-4" },
                [_c("Comments", { attrs: { commentable: _vm.post } })],
                1
              ),
              _vm._v(" "),
              _c("PostEdit", {
                ref: "postEditModal",
                attrs: { post: _vm.post },
                on: { postEdited: _vm.postEdited },
              }),
              _vm._v(" "),
              _c("ConfirmActionModal", { ref: "ConfirmAction" }),
            ],
            1
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }